if (!customElements.get('custom-faq-accordion')) {
  class CustomFaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-faq-trigger]');
        if (trigger) trigger.addEventListener('click', () => this.toggle(item));
      });
    }

    toggle(item) {
      const wasOpen = item.classList.contains('is-open');

      this.items.forEach((current) => {
        current.classList.remove('is-open');
        const trigger = current.querySelector('[data-faq-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });

      if (!wasOpen) {
        item.classList.add('is-open');
        const trigger = item.querySelector('[data-faq-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
    }
  }

  customElements.define('custom-faq-accordion', CustomFaqAccordion);
}
